/* eslint-disable */
'use strict';
exports.__esModule = true;
exports.default = {
  "account": "Conta",
  "active_date": "Data ativa",
  "address": "Endereço",
  "address2": "Endereço 2 (opcional)",
  "amount": "Valor",
  "and": "e",
  "article": "Artigo",
  "buy": "Compra",
  "buyer": "Comprador",
  "buyer_info": "Informações do comprador",
  "cancel": "Cancelar",
  "canceled": "Cancelado",
  "cellphone": "Celular",
  "certification_expires": "Não autorizado ou expirado, faça login novamente",
  "change_password": "Alterar senha",
  "city": "Cidade",
  "clear": "Limpar",
  "commercial": "Comercial",
  "company": "Empresa",
  "completed": "Concluído",
  "confirm_password": "Confirmar Senha",
  "contact": "Contato",
  "country": "País",
  "create": "Criar",
  "create_account": "Criar conta",
  "create_date": "Data de Criação",
  "creationdate": "Data de Criação",
  "currency": "Moeda",
  "customer_success": "Registro concluído, verifique seu e-mail para ativação",
  "dead_line": "Prazo",
  "dealer": "Revendedor",
  "dealer_success": "Aguardando aprovação",
  "description": "Descrição",
  "domain": "Domínio",
  "domain_in_use": "Domínio já está em uso",
  "email": "E-mail",
  "email_format_error": "Formato de e-mail inválido",
  "email_used": "E-mail já está em uso",
  "enter_character": "Insira os caracteres da imagem",
  "enter_confirm_password": "Insira a nova senha novamente",
  "enter_new_password": "Insira a nova senha",
  "enter_old_password": "Insira a senha antiga",
  "erp_list": "Assinaturas",
  "erp_status": "Status",
  "expire_date": "Data de expiração",
  "female": "Feminino",
  "first_name": "Nome",
  "forget_password": "Esqueceu a senha?",
  "forgot_password": "Esqueceu a senha?",
  "form_not_exist": "Formulário não existe",
  "format_error": "Erro de Formato",
  "group_code": "Código do grupo",
  "group_name": "Nome do Grupo",
  "home_company_address": "Endereço casa/empresa",
  "image": "Imagem",
  "information_success": "Alteração da conta concluída",
  "initial_info": "Informação inicial",
  "input_password": "Insira a senha",
  "input_password_again": "Insira a senha novamente",
  "last_name": "Sobrenome",
  "legal_person": "Pessoa jurídica",
  "male": "Masculino",
  "modify": "Modificar",
  "modify_erp_information": "Alterar info ERP",
  "modules": "Módulos",
  "month": "Usuário/mês",
  "name": "Nome",
  "new_password": "Nova Senha",
  "new_password_toEmail": "Nova senha enviada para seu e-mail",
  "next": "Próximo",
  "noFoundurl": "Instância não existe",
  "not_null": "Há campos obrigatórios não preenchidos",
  "official_website": "Site oficial:",
  "ok": "OK",
  "old_password": "Senha Antiga",
  "old_password_error": "Senha antiga incorreta",
  "one_time_payment": "Pagamento único",
  "operation": "Operação",
  "or": "OU",
  "order": "Pedido",
  "order-no": "Nº pedido",
  "order_close": "Pedido fechado",
  "order_list": "Lista de pedidos",
  "order_no": "Nº do Pedido",
  "order_status": "Status do pedido",
  "other": "Outro",
  "paid": "Pago",
  "password": "Senha",
  "password_error": "A senha deve ter 6-20 caracteres com letras e números",
  "password_error_two": "As senhas não coincidem",
  "password_least": "A senha deve ter pelo menos 6 caracteres com números e letras/caracteres especiais",
  "password_strength": "Força da Senha",
  "pay": "Compra",
  "pay_error": "Falha ao obter dados de pagamento",
  "payment": "Método de pagamento",
  "payment_date": "Data de Pagamento",
  "personal": "Pessoal",
  "please_email": "Verifique seu e-mail",
  "pos": "Posição",
  "previous": "Anterior",
  "price": "Preço",
  "privacy": "Ao criar uma conta SOMATIME, você concorda",
  "privacy_notice": "Política de privacidade",
  "product": "Produtos",
  "product_list": "Lista de produtos",
  "product_name": "Nome do Produto",
  "purchase": "Compra",
  "purchase_success": "Compra realizada",
  "refunded": "Reembolsado",
  "registered": "Este e-mail já está registrado",
  "registered_email_address": "Registramos com seu e-mail",
  "renewal": "Renovação",
  "repeat_password": "Repetir senha",
  "requied": "Obrigatório",
  "requied_num": "Apenas números",
  "require_tips": "Dados do comprador ausentes",
  "required": "Obrigatório",
  "reseller": "Revendedor",
  "resend": "Reenviar",
  "reset_password": "Enviamos um e-mail com link de confirmação para",
  "revoke": "Cancelar pedido",
  "revoke_tip1": "Deseja fechar o pedido atual?",
  "role": "Função",
  "search": "Buscar",
  "send_update": "Enviar atualizações da SOMATIME",
  "sex": "Sexo",
  "signIn": "Entrar",
  "sign_out": "Sair",
  "state": "Estado/Província",
  "status": "Status de pagamento",
  "status_not_match": "Status não corresponde",
  "strength_high": "Alto",
  "strength_low": "Baixo",
  "strength_mid": "Médio",
  "submit": "Enviar",
  "submitted": "Enviado",
  "subscribe": "Assinar",
  "subscribe-mon": "Assinatura-mensal",
  "subscript_success": "Assinatura concluída",
  "telephone": "Telefone",
  "tenant_list": "Lista de tenants",
  "tenant_management_system": "Sistema de gestão de tenants",
  "tenant_system": "Sistema de tenants",
  "terms_of_use": "Termos de uso",
  "time_info": "Informação de tempo",
  "title": "Título",
  "unpaid": "Não Pago",
  "update_password_success": "Senha alterada com sucesso",
  "user": "Usuário",
  "user_check": "Leia e aceite a política de privacidade e termos de uso",
  "user_id": "ID do usuário",
  "user_month": "Mês",
  "user_not_active": "Usuário não ativado",
  "user_not_exist": "Usuário não existe",
  "user_password_error": "Senha incorreta",
  "user_qty": "Quantidade de usuários",
  "username": "Nome de usuário",
  "ver_code_error": "Código de verificação incorreto",
  "ver_code_exd": "Código de verificação expirado",
  "visit": "Visitar",
  "welcome_to_iceq": "BEM-VINDO AO SOMATIME",
  "zip": "CEP",
  "trial": "Teste",
  "requesting_a_trial": "Solicitação concluída, info em 24h",
  "trial_orders_have_been_requested": "Solicitação de teste enviada",
  "apply_trial": "Solicitar demo",
  "request_": "Solicitação",
  "trial_": "Teste",
  "on_trial": "Em teste",
  "order_not_exist": "Pedido não existe",
  "wait_for_payment": "Aguardando pagamento",
  "trial_reject": "Demo rejeitada",
  "tips": "Dicas",
  "confirm": "",
  "cancel": "Cancelar",
  "trial_only_allow_one_time_payment_method": "Teste apenas pagamento único",
  "domain_info": "Info do domínio",
  "please_fill_in_domain_info": "Preencha info do domínio",
  "user_quantity_and_month_required": "Usuários e meses obrigatórios",
  "password_must_be_the_same": "Confirmação deve coincidir",
  "enter_the_password_and_new_password": "Insira senha e nova",
  "wrong_user_name_and_password": "Usuário/senha incorretos",
  "close_the_page_without_saving": "Fechar sem salvar?",
  "cancel_input": "Cancelar entrada",
  "user_does_not_exist": "Usuário não existe",
  "modify_success": "Alterado com sucesso",
  "email_has_been_used": "E-mail já usado",
  "created_successfully": "Criado com sucesso",
  "error_tip_10098": "Falha no envio, contate admin",
};